// extracted by mini-css-extract-plugin
module.exports = {"container":"_20mNvAEfiFpTPn_JtKowpL","loader":"DzMldzIQrOFDwq6FtgtIq"};